// React imports
import React, { cloneElement } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import compose from "recompose/compose";
import {
  translate,
  DashboardMenuItem,
  MenuItemLink,
  Responsive,
  WithPermissions
} from "react-admin";
import { withStyles } from "@material-ui/core/styles";
import Divider from "@material-ui/core/Divider";
import MenuElem, { menuItemStyles } from "./MenuElem";
import AcUnitIcon from "@material-ui/icons/AcUnit";
import AssignmentIcon from "@material-ui/icons/Assignment";
import BuildIcon from "@material-ui/icons/Build";
import BusinessIcon from "@material-ui/icons/Business";
import PeopleOutline from "@material-ui/icons/PeopleOutline";
import SettingsIcon from "@material-ui/icons/Settings";
import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";

const items = [
  {
    name: "orders",
    icon: <AssignmentIcon />,
    permissions: ["IS_ADMIN", "IS_CLIENT_ADMIN"]
  },
  {
    name: "devices",
    icon: <AcUnitIcon />,
    permissions: ["IS_ADMIN", "IS_CLIENT_ADMIN"]
  },
  {
    name: "clientCustomers",
    icon: <PeopleOutline/>,
    permissions: ["IS_ADMIN", "IS_CLIENT_ADMIN"]
  },
  
  {//
    name: "subscribers",
    icon: <BusinessIcon />,
    permissions: ["IS_ADMIN", "IS_CLIENT_ADMIN"]
  },
  {
    name: "appUsers",
    icon: <BuildIcon />,
    permissions: ["IS_ADMIN", "IS_CLIENT_ADMIN"]
  },
  {//
    name: "users",
    icon: <SupervisorAccountIcon />,
    permissions: ["IS_ADMIN", "IS_CLIENT_ADMIN"]
  },

];

const profile = "/profile/" + localStorage.getItem("userId");

const Menu = ({ onMenuClick, translate, logout, classes }) => {
  return (
    <WithPermissions
      render={({ permissions }) => (
        <div>
          <MenuElem
            items={items}
            onMenuClick={onMenuClick}
            translate={translate}
            logout={logout}
            profile={profile}
          />
          <Responsive
            xsmall={
              <div>
                <Divider style={{ margin: "8px 16px" }} />
                <MenuItemLink
                  to={profile}
                  primaryText={translate("pos.profile")}
                  leftIcon={<SettingsIcon />}
                  onClick={onMenuClick}
                  classes={classes}
                />
              </div>
            }
            medium={null}
          />
          <Responsive
            xsmall={logout && cloneElement(logout, { className: classes.root })}
            medium={null}
          />
        </div>
      )}
    />
  );
};

const enhance = compose(
  withRouter,
  connect(
    state => ({
      theme: state.theme,
      locale: state.i18n.locale
    }),
    {}
  ),
  translate,
  withStyles(menuItemStyles)
);

export default enhance(Menu);
